/**
 * @file Rudimentary FadeInLeft transition component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

const propTypes = {
  in: PropTypes.bool,
  children: PropTypes.node,
};

const duration = 125;

const defaultStyle = {
  width: '100%',
  transition: `
    opacity ${duration * 3}ms ease-in,
    transform ${duration}ms ease-in`,
};

const transitionStyles = {
  entering: { opacity: 0, transform: 'translateX(-120px)' },
  entered: { opacity: 1, transform: 'translateX(0)' },
};

const FadeInLeft = ({ in: inProp, children, ...props }) => (
  <Transition in={inProp} timeout={duration} {...props}>
    {state => (
      <div
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      >
        {children}
      </div>
    )}
  </Transition>
);

FadeInLeft.propTypes = propTypes;

export default FadeInLeft;
